// extracted by mini-css-extract-plugin
export default {"home":"home_home__mF33h"};